/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, since: NonNullable<unknown> }} No_Intensity_During_Teach_InInputs */



/**
* | since | output |
* | --- | --- |
* | "false" | "No intensity detection during teach-in" |
* | "true" | "No intensity detection during teach-in since {date}" |
* | * | "No intensity detection during teach-in" |
*
* @param {No_Intensity_During_Teach_InInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const no_intensity_during_teach_in = /** @type {((inputs: No_Intensity_During_Teach_InInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Intensity_During_Teach_InInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.since === "false") return /** @type {LocalizedString} */ (`No intensity detection during teach-in`);
		if (i?.since === "true") return /** @type {LocalizedString} */ (`No intensity detection during teach-in since ${i?.date}`);
		return /** @type {LocalizedString} */ (`No intensity detection during teach-in`)
	}
	{
		if (i?.since === "false") return /** @type {LocalizedString} */ (`Pas de détection d'intensité lors de l'apprentissage`);
		if (i?.since === "true") return /** @type {LocalizedString} */ (`Pas de détection d'intensité lors de l'apprentissage depuis le ${i?.date}`);
		return /** @type {LocalizedString} */ (`Pas de détection d'intensité lors de l'apprentissage`)
	}
});